import { h, Component } from "preact";
// import styles from "./style.scss";
import TranslateBox from "../translate-box";

export default class App extends Component {
  render(props) {
    return <TranslateBox />;
  }
}



// WEBPACK FOOTER //
// ./components/translate/index.js